/* eslint-disable react/no-did-update-set-state */
/* eslint-disable react/destructuring-assignment */
import React, { Component } from 'react'
import { withTranslation } from 'react-i18next';
import classNames from 'classnames';
import some from 'lodash/some'

import { Dialog } from 'primereact/dialog';
import { InputTextarea } from 'primereact/inputtextarea';

class JustificationModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      justification: '',
      errors: []
    }
  }

  componentDidUpdate (prevProps) {
    if (!prevProps.display && this.props.display) {
      this.setState({
        justification: '',
        errors: []
      })
    }
  }

  onSubmit = async (e) => {
    e.preventDefault();
    const { onContinueAction, onHidden } = this.props
    const { justification } = this.state
    const validate = await this.validateFieldsReject()
    if (some(validate, {})) return true
    onContinueAction({justification})
    return onHidden()
  }

  validateFieldsOnchange = (name, value) => {
    const { errors } = this.state
    if (errors[name] && value) {
      delete errors[name]
      this.setState({errors})
    }
  }

  validateFieldsReject = async () => {
    const { t, label } = this.props
    const { justification } = this.state
    let errors = {}
    if (!justification) errors = { ...errors, 'justification': `${t( label || 'Justificación del cambio')} ${t('es requerido')}`}
    this.setState({errors})
    return errors
  }

  isFormFieldValid = (name) =>
    !!(this.state.errors[name]);

  getFormErrorMessage = (name) =>
    this.isFormFieldValid(name) && (
      <small className="p-error">{this.state.errors[name]}</small>
    );
  
  render () {
    const { t, display, title, onHidden, description, label, descriptionAlt, btnOkLabel } = this.props

    const children = (
      <form className="p-mt-2 p-fluid" onSubmit={this.onSubmit}>
        <div className="p-col">
          <label className="">{description}</label>
          {descriptionAlt}
        </div>
        <div className="p-col">
          <label className="">{label || t('Justificación del cambio')}</label>
        </div>
        <InputTextarea
          name="justification"
          onChange={(e) =>
            this.setState({ justification: e.target.value }, this.validateFieldsOnchange('justification', e.target.value))
          }
          rows={5}
          cols={30}
          className={classNames({
            'p-invalid': this.isFormFieldValid(`justification`),
          })}
        />
        {this.getFormErrorMessage(`justification`)}
        <div className="p-dialog-footer custom">
          <div>
            <button className="p-button p-component p-button-raised p-button-secondary p-button-text" type="button" onClick={() => onHidden()}>
              <span className="p-button-label p-c">Cerrar</span>
            </button> 
            <button className="p-button p-component" type="submit">
              <span className="p-button-label p-c">{btnOkLabel || 'Continuar'}</span>
            </button>
          </div>
        </div>
      </form>
    )

    return (
      <Dialog
        header={title}
        visible={display}
        breakpoints={{'960px': '90vw'}}
        style={{ width: '50vw' }}
        onHide={onHidden}
      >
        {children}
      </Dialog>
    )
  }
}

export default withTranslation()(JustificationModal)